import {Nullish} from 'shared/web';

import {PriceWithAndWithoutVat} from './PriceWithAndWithoutVat';

export type Basket<T> = {
  items: T[] | Nullish;
  totalPrice: PriceWithAndWithoutVat | Nullish;
  isLoading: boolean;
  hasError: boolean;
  hasPendingRequest: boolean;
  hasInvalidItems: boolean;
  isPriceHidden?: boolean;
  isEditItemHidden?: boolean;
  isDispensingUnitValidationDisabled?: boolean;
};
